/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class CatalogOperationResponse {
  /**
  * HTTP status code returned by the catalog service
  */
  'statusCode': number;
  /**
  * Opaque response body from the catalog service
  */
  'body'?: any | null;
  /**
  * Error message if the proxy itself failed (e.g., service unreachable)
  */
  'error'?: string | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "statusCode",
      "baseName": "statusCode",
      "type": "number",
      "format": ""
    },
    {
      "name": "body",
      "baseName": "body",
      "type": "any",
      "format": ""
    },
    {
      "name": "error",
      "baseName": "error",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CatalogOperationResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

